// @ts-nocheck
import {fromEvent, Subscription} from "rxjs";

const spacer: number = 50;

export class Accordion {
    private accordionHeader: NodeListOf<Element>;
    private initialState: boolean;

    constructor() {
    }

    config() {

        let container =  document;

        this.accordionHeader = container.querySelectorAll('[accordion-header]');
        this.initialState = true;
    }
    public sub: Subscription[] = [];


    init() {

        let container =  document;

        if(!container.querySelector('.accordion')) {
            return;
        }

        this.config();
        const click = fromEvent(this.accordionHeader, 'click');

        let timeout;

        click.subscribe ((e) => {

            const state = ( <HTMLElement>e.target ).closest('.accordion__item').classList.contains('accordion__item--opened');
            const currentTab = ( <HTMLElement>e.target ).closest('.accordion__item');

            if(currentTab.classList.contains('accordion--pending')) return;

            if(state) {
                currentTab.classList.remove('accordion__item--opened');
                if(timeout) clearTimeout(timeout);
                currentTab.querySelector('[accordion-body]').style.overflow = '';
            } else {
                currentTab.classList.add('accordion__item--opened');
                timeout = setTimeout(() => {
                    currentTab.querySelector('[accordion-body]').style.overflow = 'initial';
                }, 400)
            }

        });

        const accordionItems = container.querySelectorAll('[accordion-header]');

        const clickEvent = fromEvent(accordionItems, 'click');

        clickEvent.subscribe((e) => {

            const currentTab = ( <HTMLElement>e.target ).closest('.accordion__item');

            if(container.querySelector('.accordion-backend')) {
                currentTab.classList.add('accordion__item--opened');
                return;
            }

            let contentElement: Element = (e.currentTarget).closest('.accordion__item').querySelector('.accordion__item__content');
            const wrap = (<HTMLElement>e.currentTarget).closest('.accordion__item').querySelector('[accordion-body]');

            if(currentTab.classList.contains('accordion--pending')) return;

            currentTab.classList.add('accordion--pending');

            if (wrap.style.maxHeight) {
                wrap.style.maxHeight = contentElement.scrollHeight + spacer + "px";
                setTimeout(() => {
                    wrap.style.maxHeight = null;
                }, 5)

            } else {
                wrap.style.maxHeight = contentElement.scrollHeight + spacer + "px";
                setTimeout(() => {
                    wrap.style.maxHeight = 'none'
                }, 500)
            }

            setTimeout(() => {
                currentTab.classList.remove('accordion--pending');
            }, 500)
        });
    }

    destroy(){
        this.sub.forEach((sub: Subscription) => sub.unsubscribe());
    }


}
